module.exports = __webpack_public_path__ + "img/Clockwerk.e1541d37.png";